import { format } from "date-fns";
import { Timestamp } from "firebase/firestore";

export class TimeField {
  public static fromFirestore(value: unknown): string | undefined {
    if (value === null || value === undefined) return undefined;

    return value as string;
  }

  public static toFirestore(value: Date | undefined): Timestamp | null {
    if (value === null || value === undefined) return null;

    return Timestamp.fromDate(value);
  }

  public static fromOfflineCache(value: unknown): string | undefined {
    return TimeField.fromFirestore(value);
  }

  public static toOfflineCache(value: Date | undefined): string | null {
    if (value === null || value === undefined) return null;

    return value.toISOString();
  }

  public static toStringValue(value: Date | undefined, defaultValue: string, dateFormat = "yyyy-MM-dd"): string {
    if (value === null || value === undefined) return defaultValue;

    return format(value, dateFormat);
  }
}
